<template>
  <SoDialog
    :model-value="prompt.isOpen"
    card-title="Save this number to the customer's contact details?"
    :max-width="560"
    persistent
    data-testid="save-contact-number-modal"
  >
    <p class="mb-6">
      The customer has no contact number on file. Ask them if they'd like
      <strong data-testid="save-contact-number-value">{{
        prompt.phoneNumber
      }}</strong>
      saved to their contact details, so we can reach them about future
      appointments.
    </p>
    <div class="d-flex justify-end ga-4">
      <SoButton
        title="No, just for this booking"
        large
        :disabled="updateContactMutator.isPending"
        @click="prompt.answered()"
      />
      <SoButton
        title="Yes, save it"
        type="success"
        large
        :loading="updateContactMutator.isPending"
        @click="saveNumber"
      />
    </div>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoDialog from "@/components/SoDialog.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import { IContact } from "@/models/contacts/contact.types"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { useSnackbarStore } from "@/stores/snackbar"
  import { useImbpSaveContactNumberPromptStore } from "@/stores/imbpSaveContactNumberPrompt"

  export default defineComponent({
    components: {
      SoDialog,
      SoButton,
    },
    data() {
      return {
        updateContactMutator: useCurrentAccountStore().updateContact(),
        snackbar: useSnackbarStore(),
        prompt: useImbpSaveContactNumberPromptStore(),
      }
    },
    methods: {
      /*
        Either answer moves the booking on to the next step. A failed save
        must not block the booking - the number is still sent with it - so a
        rejection is reported and the flow continues either way.
      */
      saveNumber() {
        this.updateContactMutator
          .mutateAsync({
            contact: this.prompt.contact as IContact,
            edits: { phone1: this.prompt.phoneNumber.replace(/\s/g, "") },
          })
          .then(() => {
            this.snackbar.addSuccess(
              "Saved the number to the customer's contact details. It may take some time for the change to show",
            )
          })
          .catch(() => {
            this.snackbar.addError(
              "Couldn't save the number to the customer's contact details. It will still be used for this booking",
            )
          })
          .finally(() => {
            this.prompt.answered()
          })
      },
    },
  })
</script>
